module.exports = __webpack_public_path__ + "img/8932453.jpg";